module.exports = __webpack_public_path__ + "img/record.8d4b01c9.jpg";